<template>
    <div>
        <div class="new-message">
            <div class="new-message__inp">
                <input type="text" v-model="message" class="" @keydown.enter="sendMessage"
                       placeholder="Write message..."/>
            </div>
            <div class="btn btn-primary new-message__btn" @click="sendMessage">
                <i class="fa fa-envelope"></i>
                Надіслати
            </div>
        </div>


        <div v-for="message in messages"
             :class="{'is_teacher':message.teacher || !message.teacher && !message.student}"
             class="panel panel-default panel_messages" data-z="0.5"
             data-animated
        >
            <div class="panel-body">
                <div class="media v-middle">
                    <div class="media-left">
                        <img v-if="message.avatar" :src="message.avatar" alt="person"
                             class="media-object img-circle width-50 height-50 "/>
                        <div v-else-if="message.teacher" class="z-initials">{{message.teacher.initials}}</div>
                        <div v-else-if="message.student" class="z-initials">{{message.student.initials}}</div>
                        <div v-else class="z-initials">ЗЧ</div>
                    </div>
                    <div class="media-body message">
                        <h4 class="text-subhead margin-none">
                            <a href="#">{{ message.messages.split(':')[0] }}</a>
                        </h4>
                        <!--<p v-if="message.time_from.min" class="text-caption text-light">
                            <i class="fa fa-clock-o"></i>
                            min {{ message.time_from.min }}
                        </p>
                        <p v-else-if="message.time_from.hours" class="text-caption text-light">
                            <i class="fa fa-clock-o"></i>
                            hours {{ message.time_from.hours }}
                        </p>
                        <p v-else-if="message.time_from.days" class="text-caption text-light">
                            <i class="fa fa-clock-o"></i>
                            days {{ message.time_from.days }}
                        </p>-->
                        <div class="chat-message__date">{{ message.date_create }}</div>
                    </div>
                </div>
                <!--<p>{{ message.messages.split(':').length > 2 ? (message.messages.split(':')[1]+':'+message.messages.split(':')[2]) : message.messages.split(':')[1] }}</p>-->
                <p><span v-html=" scrollMessage(message.messages) "></span></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChatTeacherComponent",
    props: {
        messages: Array,
        teacher: '',
        student: ''
    },
    data() {
        return {
            message: null,
            posBoxY: 0,
        }
    },
    computed: {

    },
    mounted() {
        // this.scrollMessage()
    },
    methods: {
        sendMessage() {
            this.$emit('sendMessage', {
                message: this.message,
            })
            this.message = '';
        },

        scrollMessage(mes) {
            var arr = mes.split(':');
            arr.shift();
            var str = arr.join(':');
            return str;
        }
    }
}
</script>

<style>

</style>
